export default __webpack_public_path__ + "static/media/bb2.1.97cffafc.png";